import { ValueGetterParams } from 'ag-grid-community';
import { budgetPercentageFormatter } from 'ui/AgGridReact/formatters';

export const calculateEvolution = (
    totalAmountRequested: number,
    totalAmountVoted: number,
): number | null => {
    if (totalAmountVoted === 0) {
        // Inscription that was created this exercice
        return null;
    }

    // @ts-expect-error [TS migration] Was not detected by flow
    if ([null, 'unknown'].includes(totalAmountRequested)) {
        // Inscription that has not been filled yet for this exercice
        return null;
    }

    return (totalAmountRequested - totalAmountVoted) / totalAmountVoted;
};

const aggEvolutionValueGetter = (params: ValueGetterParams<ResponseDataT>) => {
    if (!params) return '';
    const field = params.colDef.field ?? '';
    const aggregatedData =
        params?.node?.aggData &&
        calculateEvolution(
            params?.node?.aggData[field].totalAmountRequested,
            params?.node?.aggData[field].totalAmountVoted,
        );
    return aggregatedData || '';
};

export const aggEvolutionGetter = (
    params: ValueGetterParams<ResponseDataT>,
): number => 100 * aggEvolutionValueGetter(params);

export const calculateEvolutionInPercentage = (
    totalAmountRequested: number,
    totalAmountVoted: number,
    t: TranslationT,
): string | null => {
    // Inscription that was created this exercice, or was created but was at 0
    if (totalAmountVoted === null || totalAmountVoted === 0) {
        if (totalAmountRequested === null || totalAmountRequested === 0) {
            return '-';
        }

        return t('common.new');
    }
    // Inscription existed with non-0 value

    // Inscription that has not been filled yet for this exercice
    // @ts-expect-error [TS migration] Was not detected by flow
    if ([null, 'unknown'].includes(totalAmountRequested)) {
        return '-100%';
    }
    return budgetPercentageFormatter({
        value: (totalAmountRequested - totalAmountVoted) / totalAmountVoted,
    });
};
